import React from "react";

const Settings = () => {
  return <div>This is Settings</div>;
};

export default Settings;
